import { AnalyticsStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkEmptyState, UitkEmptyStateActionArea } from 'uitk-react-empty-state';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkTertiaryButton } from 'uitk-react-button';

import { handleRetry } from 'utils/error-handling-utils';

import { PackageError } from '../multi-item/package-error';

interface SearchErrorMessageProps {
  analytics?: AnalyticsStore;
  searchResults?: SearchResultsStore;
}

export const SearchErrorMessageWrapper: React.FC<SearchErrorMessageProps> = inject(
  'searchResults',
  'analytics'
)(({ searchResults, analytics }) => {
  const { formatText } = useLocalization();

  const history = useHistory();
  const location = useLocation();

  const isError = searchResults?.isError;
  const isEmpty = searchResults?.isEmpty;
  const searchCriteria = searchResults?.searchCriteria;
  const { misId } = searchCriteria || {};
  if (!isError && !isEmpty) {
    return null;
  }

  if (misId) {
    return (
      <UitkSpacing padding={{ blockstart: 'six', blockend: 'twelve' }}>
        <div>
          <UitkText align="center">
            <PackageError searchResults={searchResults} analytics={analytics} />
          </UitkText>
        </div>
      </UitkSpacing>
    );
  }
  const errorMessage =
    !isError && isEmpty ? formatText('hotels.searchResults.emptyResults.text') : formatText('hotels.searchResults.error.text');
  const errorCta = isError ? formatText('hotels.searchResults.error.cta') : '';

  return (
    <UitkSpacing padding={{ blockend: 'twelve' }}>
      <div data-stid="empty-state-error">
        <UitkText align="center">
          <UitkSpacing padding={{ blockstart: 'three' }}>
            <UitkEmptyState data-stid={'retry-search'}>
              <UitkIcon name={'error'} />
              <UitkHeading tag="h2">{errorMessage}</UitkHeading>
              <UitkEmptyStateActionArea>
                <UitkTertiaryButton
                  name="textonly"
                  onClick={() => handleRetry(':errorOnSearch', 'Try Again on error', analytics, searchResults, history, location)}
                  type="button"
                >
                  {errorCta}
                </UitkTertiaryButton>
              </UitkEmptyStateActionArea>
            </UitkEmptyState>
          </UitkSpacing>
        </UitkText>
      </div>
    </UitkSpacing>
  );
});
